<template>
  <div class="min-h-screen bg-[#0F0F0F] text-white py-10 px-4 md:px-10">
    <div
      class="max-w-4xl mx-auto bg-[#1F1F1F] p-8 rounded-2xl shadow-xl border border-gray-700"
    >
      <h1 class="text-3xl md:text-4xl font-bold text-center mb-8">
        {{ $t("privacy.title") }}
      </h1>

      <div class="space-y-6 text-gray-300 text-sm leading-relaxed">
        <section>
          <h2 class="text-xl font-semibold text-white mb-2">
            {{ $t(`privacy.sections.0.title`) }}
          </h2>
          <p>
            {{ $t(`privacy.sections.0.description`) }}
          </p>
        </section>

        <section>
          <h2 class="text-xl font-semibold text-white mb-2">
            {{ $t(`privacy.sections.1.title`) }}
          </h2>

          <ul class="list-disc list-inside space-y-1">
            <li>{{ $t(`privacy.sections.1.list[0]`) }}</li>
            <li>{{ $t(`privacy.sections.1.list[1]`) }}</li>
            <li>{{ $t(`privacy.sections.1.list[2]`) }}</li>
            <li>{{ $t(`privacy.sections.1.list[3]`) }}</li>
          </ul>
        </section>
        <section>
          <h2 class="text-xl font-semibold text-white mb-2">
            {{ $t(`privacy.sections.2.title`) }}
          </h2>
          <p>{{ $t(`privacy.sections.2.description`) }}</p>
          <ul class="list-disc list-inside space-y-1">
            <li>{{ $t(`privacy.sections.2.list[0]`) }}</li>
            <li>{{ $t(`privacy.sections.2.list[1]`) }}</li>
            <li>{{ $t(`privacy.sections.2.list[2]`) }}</li>
            <li>{{ $t(`privacy.sections.2.list[3]`) }}</li>
            <li>{{ $t(`privacy.sections.2.list[4]`) }}</li>
          </ul>
        </section>

        <section>
          <h2 class="text-xl font-semibold text-white mb-2">
            {{ $t(`privacy.sections.3.title`) }}
          </h2>
          <p>
            {{ $t(`privacy.sections.3.description`) }}
          </p>
        </section>

        <section>
          <h2 class="text-xl font-semibold text-white mb-2">
            {{ $t(`privacy.sections.4.title`) }}
          </h2>
          <p>
            {{ $t(`privacy.sections.4.description`) }}
          </p>
        </section>

        <section>
          <h2 class="text-xl font-semibold text-white mb-2">
            {{ $t(`privacy.sections.5.title`) }}
          </h2>
          <p>{{ $t(`privacy.sections.5.description`) }}</p>
          <ul class="list-disc list-inside space-y-1">
            <li>{{ $t(`privacy.sections.5.list[0]`) }}</li>
            <li>{{ $t(`privacy.sections.5.list[1]`) }}</li>
            <li>{{ $t(`privacy.sections.5.list[2]`) }}</li>
            <li>{{ $t(`privacy.sections.5.list[3]`) }}</li>
            <li>{{ $t(`privacy.sections.5.list[4]`) }}</li>
          </ul>
        </section>

        <section>
          <h2 class="text-xl font-semibold text-white mb-2">
            {{ $t(`privacy.sections.6.title`) }}
          </h2>
          <p>
            {{ $t(`privacy.sections.6.description`) }}
          </p>
        </section>

        <section>
          <h2 class="text-xl font-semibold text-white mb-2">
            {{ $t(`privacy.sections.7.title`) }}
          </h2>
          <p>
            {{ $t(`privacy.sections.7.description`) }}
          </p>
        </section>

        <section>
          <h2 class="text-xl font-semibold text-white mb-2">
            {{ $t(`privacy.sections.8.title`) }}
          </h2>
          <p>
            {{ $t(`privacy.sections.8.description`) }}
          </p>
        </section>
      </div>

      <div class="mt-10 text-center text-gray-500 text-xs">
        © {{ new Date().getFullYear() }} MEM22 Akademi – Tüm hakları saklıdır.
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
definePageMeta({ layout: "default" });
</script>
